import React from "react"
import { ProviderFinderParam, useBooleanSearchParam } from "../../utils/providerFinderSearchUrl"
import { FormattedMessage, useIntl } from "react-intl"
import {
  BadgeIcon,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography
} from "@carrotfertility/carotene-core"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"

export function CarrotPartnerFilter(): JSX.Element {
  const [carrotPartnerSearchParam, setCarrotPartnerSearchParam] = useBooleanSearchParam(
    ProviderFinderParam.CarrotPartner
  )
  const intl = useIntl()
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()

  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.md)}>
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: (theme) => theme.spacing(theme.tokens.spacing.xxs),
                  minBlockSize: (theme) => theme.spacing(theme.tokens.spacing.lg)
                }}
              >
                <BadgeIcon fontSize="small" color="primary" />
                <Typography fontWeight="bold" textTransform="uppercase" fontSize="0.75rem">
                  <FormattedMessage defaultMessage="Exclusive benefits" />
                </Typography>
              </Box>
            }
            aria-label={intl.formatMessage({ defaultMessage: "Select carrot partner type" })}
            control={
              <Checkbox
                name="carrotPartner"
                checked={carrotPartnerSearchParam}
                onChange={(event) => {
                  const isChecked = event.target.checked
                  setCarrotPartnerSearchParam(isChecked)
                  addMemberAction({
                    memberActionTaken: MemberActions.PROVIDER_FINDER_CARROT_PARTNER_FILTER_TOGGLED,
                    metaData: {
                      filterEnabled: isChecked,
                      memberJourney: resolvedJourney
                    }
                  })
                }}
              />
            }
          />
          <FormHelperText sx={{ paddingInlineStart: (theme) => theme.spacing(theme.tokens.spacing.xxl) }}>
            <FormattedMessage defaultMessage="Carrot partner providers offer valuable discounts or faster response times." />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}
